import React from "react";
// import { setCustomerInfo } from "./actions";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { change, reduxForm, formValueSelector } from "redux-form";
import TravellerFormList from "./components/TravellerFormList";
import ContactInfoForm from "./components/ContactInfoForm";
import DownPaymentButton from "./components/DownPaymentButton";
import AgreementCheckbox from "./components/AgreementCheckbox";

import { getSelectedTrip } from "../../../data/trips/selectors";
import { getLandingPageFormValues } from "../../../data/landingPageForm/selectors";
import { getCustomerInfo } from "./selectors";
import validate from "./validate";

import { submitPaymentAndPoll } from "./actions";
import { setReservedTrip } from "../../../data/trips/actions";

import { USE_MOCK_DATA } from "../../../constants";
// import DownPaymentButton from "./components/DownPaymentButton";
// import MenuItem from 'material-ui/MenuItem'
import { getTravellerFormInfoArr, getTravellerFormValues } from "./selectors";
// import {
//   // DatePicker,
//   // SelectField,
//   TextField
// } from "redux-form-material-ui";
import "./styles.css";
// import LoadingPage from "../../../components/LoadingFlightsPage";

// This function was ripped from server (formatter.js) to prep
// data for /reservations page
// TODO Eventually, send the raw order from db, and let client use this
// function and redux action to prep reservation page data
const formatReservation = order => {
  var isRoundTrip = !!order.tripInfo.returning;

  return {
    tripFinancials: order.tripFinancials,
    numberOfETickets: order.tripInfo.numberOfETickets,
    orderId: order.createdAt,
    isRoundTrip: isRoundTrip,
    departDateDisplay: order.tripInfo.departing.departureDateDisplay,
    returnDateDisplay:
      isRoundTrip && order.tripInfo.returning.departureDateDisplay,
    email: order.customerInfo.contactInfo.email,
    // downPayment: order.tripFinancials.downPayment,
    // installmentPayment: order.tripFinancials.installmentPayment,
    // installmentDates: order.tripFinancials.installmentDates,
    // totalCost: order.tripFinancials.totalCost,
    departingTripSegments: order.tripInfo.departing.tripSegments,
    returningTripSegments: isRoundTrip && order.tripInfo.returning.tripSegments
  };
};

class CustomerInfoForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isDisabledSubmitButtonClicked: false };
  }

  // When Stripe sends a response after clicking submit button
  onTokenReceived = token => {
    const {
      dispatch,
      history,
      customerInfo,
      selectedTrip,
      ppnBookBundle
    } = this.props;
    const { card } = token;
    const { tripFinancials, tripInfo } = selectedTrip;
    // We don't need to send fareRules to db
    delete tripFinancials.fareRules;
    // const createdAt = new Date().getTime();

    // Prepare Order object that will be persisted in db
    const order = {
      tripInfo,
      tripFinancials,
      customerInfo
      // createdAt
    };
    // console.log('somto token', JSON.stringify(token))
    const requestPayload = {
      last4: card.last4,
      exp_year: card.exp_year,
      exp_month: card.exp_month,
      tokenId: token.id,
      // tokenEmail: token.email,
      ppnBookBundle,
      order
    };

    // Prepare data for Reservations/Order Confirmation page
    const reservedTrip = formatReservation(order);
    // Artificially attached charges property, so /reservations will load.
    // This mimicks what the server would do if going from /find-my-trip to /reservations
    reservedTrip.charges = [
      { amount: reservedTrip.tripFinancials.downPayment * 100 }
    ];
    // Set reservedTrip data in redux which will be displayed in Reservations/Order Confirmation page eventually
    dispatch(setReservedTrip(reservedTrip));

    // Submit customer info from Stripe to our servers
    dispatch(submitPaymentAndPoll({ history, requestPayload }));
  };

  onDisabledSubmitButtonClick = () => {
    const { handleSubmit: handleSubmitReduxForm } = this.props;

    // This attempts to submit redux form, and displays error messages as form isn't ready here
    const fakeHandleSubmit = () => {};
    handleSubmitReduxForm(fakeHandleSubmit)();

    this.setState({ isDisabledSubmitButtonClicked: true });
  };

  // // Handle the clicking of "Next" btn
  // handleSubmit = (values, e) => {
  //   const { dispatch, history } = this.props;

  //   dispatch(setCustomerInfo(values));
  //   // console.log("somto e", e);
  //   // history.push("review-order");
  // };

  handleDateOfBirthChange = (dobAttributeName, dob) => {
    this.props.dispatch(change("customerInfo", dobAttributeName, dob));
  };
  // countries = () => [<MenuItem key={1} value='United States' primaryText='United States' />]

  render() {
    const {
      // handleSubmit: handleSubmitReduxForm,
      // valid: customerInfoFormIsValid,
      apiErrorMessage,
      customerInfoFormIsSubmitting,
      valid, // Provided by redux-form; true when all form fields don't yield errors
      // passengers,
      travellerFormInfoArr,
      downPayment,
      totalCost,
      installmentPayment,
      // isAgreementChecked,
      email
    } = this.props;

    const customerInfoFormIsReadyForSubmission =
      !customerInfoFormIsSubmitting && valid;
    const isMultiplePassengers = travellerFormInfoArr.length > 1;
    const onTokenReceived = this.onTokenReceived;
    const isDisabledSubmitButtonClicked = this.state
      .isDisabledSubmitButtonClicked;
    const onDisabledSubmitButtonClick = this.onDisabledSubmitButtonClick;

    var errorMessage;
    const formSubmissionError =
      isDisabledSubmitButtonClicked && !customerInfoFormIsReadyForSubmission;

    if (formSubmissionError)
      errorMessage = "Please check agreement, and fill required form fields.";
    if (apiErrorMessage) errorMessage = apiErrorMessage;

    return (
      <div>
        <h3> Customer Information </h3>
        <div class="passengers-form-wrapper">
          <h6> {isMultiplePassengers ? "Passengers" : "Passenger"} </h6>
          <TravellerFormList
            // passengers={passengers}
            showHeader={isMultiplePassengers} // show headers "Adult 1", "Child 1" etc.
            travellerFormInfoArr={travellerFormInfoArr}
            handleDateOfBirthChange={this.handleDateOfBirthChange}
          />
        </div>

        <div class="contact-info-form-wrapper">
          <h6>Contact Information</h6>
          <ContactInfoForm />
        </div>
        <DownPaymentButton
          {...{
            displayLoadingButton: customerInfoFormIsSubmitting,
            errorMessage,
            customerInfoFormIsReadyForSubmission,
            onTokenReceived,
            isDisabledSubmitButtonClicked,
            onDisabledSubmitButtonClick,
            downPayment,
            email
          }}
        />
        <AgreementCheckbox
          {...{
            installmentPayment,
            totalCost,
            downPayment
          }}
        />
      </div>
    );
  }
}

// Decorate with redux-form
let reduxFormDecoratedComp = reduxForm({
  form: "customerInfo",
  validate
})(CustomerInfoForm);

function mapStateToProps(state) {
  const selectedTrip = getSelectedTrip(state);
  const {
    downPayment,
    totalCost,
    installmentPayment
  } = selectedTrip.tripFinancials;

  return {
    selectedTrip,
    downPayment,
    totalCost,
    installmentPayment,
    customerInfoFormIsSubmitting: state.customerInfoForm.isSubmitting,
    apiErrorMessage: state.customerInfoForm.apiErrorMessage, // errormessage fron form submission
    isRoundTrip: getLandingPageFormValues(state).isRoundTrip,
    ppnBookBundle: state.trips.installmentInfo.ppnBookBundle,
    fetchingTrips: state.trips.fetchingTrips,
    travellerFormInfoArr: getTravellerFormInfoArr(state),
    travellerFormValues: getTravellerFormValues(state),
    customerInfo: getCustomerInfo(state),
    email: formValueSelector("customerInfo")(state, "email"), // formValueSelector helps handle null/undefined states
    isAgreementChecked: formValueSelector("customerInfo")(
      state,
      "agreementCheckbox"
    ),

    // initialValues: { ...state.customerInfoPage }
    initialValues: USE_MOCK_DATA && {
      email: "okolialex@gmail.com",
      phone: "888-999-1111",
      agreementCheckbox: true,
      "gender_Adult 1": "F",
      "firstName_Adult 1": "Jane",
      "lastName_Adult 1": "Doe",
      "dob_Adult 1": "1990-02-02"
    }
  };
}

// Using withRouter(...) to get history obj, to move to next page upon form submit!
export default withRouter(connect(mapStateToProps)(reduxFormDecoratedComp));



// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/CustomerInfoForm/index.js